import { render, staticRenderFns } from "./CmgFeatured.vue?vue&type=template&id=7ab6edc4&scoped=true&lang=pug&"
import script from "./cmg-featured.ts?vue&type=script&lang=ts&"
export * from "./cmg-featured.ts?vue&type=script&lang=ts&"
import style0 from "./CmgFeatured.vue?vue&type=style&index=0&id=7ab6edc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab6edc4",
  null
  
)

export default component.exports